// src/components/PrivateRoute.tsx
import React from 'react';
import { Navigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { RootState } from '../store/GlobalStore';

interface PrivateRouteProps {
    Component: React.ReactElement;
  }

const PrivateRoute: React.FC<PrivateRouteProps> = ({ Component }) => {
  const user = useSelector((state: RootState) => state.Auth);
  console.log(JSON.stringify(user))
  return user.jwt === null ? <Navigate to="/login" /> : Component;
};

export default PrivateRoute;
